var watchlistList = {
	caption: "Watchlist list",
	name: "Nome",
	numberOfPositions: "Numero di Posizioni",
	actions: "Azioni",
	createWatchlistAction: "Crea Wtchlist",
	editWatchlistAction: "Modifica Watchlist",
	deleteWatchlistAction: "Elimina Watchlist",
	noWatchlist: {
		title: "Info",
		message: "Nessuna watchlist è stata ancora creata. Fare clic sul pulsante Crea Watchlist e compilare il modulo per creare una watchlist."
	},
	showActions: "Mostra azioni"
};
var it = {
	watchlistList: watchlistList
};

export { it as default, watchlistList };
